import { MainView } from '../../../views/create/mypage';

export default function Component(props) {
    return (
        <>
            <MainView />
        </>
    );
}